import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import MediaQueries from 'react-responsive';

import Position from '@marvelapp/marvel-ui/position';
import Spacing from '@marvelapp/marvel-ui/spacing';

import MarvelLogo from 'marketing-website/components/commons/MarvelLogo';
import ArrowButton from 'marketing-website/components/commons/ArrowButton';

import styles from './style/landing-pages-wrap.module.css';

export default class LandingPagesWrap extends Component {
  // TODO: Fix by passing down last location in react-router
  goBack = history => {
    if (
      document &&
      document.referrer &&
      (document.referrer === '' ||
        !document.referrer.split('/')[2].includes(window.location.hostname))
    ) {
      window.location.href = '/';
    } else {
      history.history.goBack();
    }
  };

  render() {
    const { children, showBackButton, history, color } = this.props;
    return (
      <div>
        <Position type="absolute" location="topLeft" fullWidth>
          <div className={styles.wrapHeader}>
            <Position location="center">
              <MediaQueries minHeight={790}>
                <Spacing type="padding" size="m">
                  <Link to="/">
                    <MarvelLogo display="inlineBlock" color={color} />
                  </Link>
                </Spacing>
              </MediaQueries>

              <MediaQueries maxHeight={789}>
                <Spacing type="padding" size="m">
                  <Link to="/">
                    <MarvelLogo display="inlineBlock" color={color} />
                  </Link>
                </Spacing>
              </MediaQueries>
            </Position>
            {showBackButton && (
              <Position location="topLeft">
                <Spacing type="padding" size="m">
                  <ArrowButton
                    isReversed
                    onClick={() => this.goBack(history)}
                  />
                </Spacing>
              </Position>
            )}
          </div>
        </Position>
        {children}
      </div>
    );
  }
}

LandingPagesWrap.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  history: PropTypes.object,
  showBackButton: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/modules/LandingPagesWrap/index.js